import { themes } from 'kb-shared';
import React from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';

import { showErrorToast } from '../../utilities/notificationUtils';
import { isValidFileExtension, showErrorValidExtensionToast } from '../../utilities/fileValidation';
import { ReactComponent as PaperclipIcon } from '../../assets/icons/paperclip.svg';

const { breakpoints } = themes;

const fileListArray = (fileList: FileList) => {
  return Array.prototype.slice.call(fileList);
};
interface ContainerProps {
  hasItems?: boolean;
}

const Container = styled.div`
  width: 100%;
  margin-top: 20px;
  margin-bottom: ${({ hasItems }: ContainerProps) => (hasItems ? '0' : '10px')};
`;

const FileAttachmentContainer = styled.div`
  cursor: pointer;
  @media (max-width: ${breakpoints.tabletPortrait}) {
    align-self: center;
  }
`;

const AttachFileName = styled.span`
  font-weight: bold;
  text-decoration: underline;
  font-size: 10pt;
  margin-bottom: 5px;
  margin: 0px 5px;
`;
const AttachFileText = styled.span`
  font-weight: bold;
  text-decoration: underline;
  font-size: 10pt;
  margin-bottom: 5px;
  margin: 0px 5px;
  ${({ theme }) => theme.fonts.FoundersGrotesk};
`;

const FileListWrapper = styled.div`
  display: flex;
`;

const FileItemWrapper = styled.div`
  display: flex;
  margin-right: 10px;
`;

const FileAttachmentWrapper = styled.div`
  display: flex;
`;

const FileAttachmentWrapperDescription = styled.small`
  ${themes.fonts.FoundersGrotesk};
  font-size: 12px;
  display: inline-block;
`;

const FileAttachment = styled.input`
  cursor: pointer;
  position: absolute;
  opacity: 0;
`;

const RemoveAttachment = styled.button``;

const renderAttachmentLink = (file: File, idx: number, onDelete: () => void) => {
  return (
    <FileItemWrapper key={idx}>
      <PaperclipIcon />
      <AttachFileName>{file.name}</AttachFileName>
      <RemoveAttachment onClick={onDelete}>X</RemoveAttachment>
    </FileItemWrapper>
  );
};

type Props = {
  listOfAttachments: File[];
  setListOfAttachments: any;
  onDeleteAttachment: (idx: number) => void;
};

export const MessageAttachmentUpload = (props: Props) => {
  const MAX_MEGABYTES = 100;
  const { t } = useTranslation();
  const { listOfAttachments, setListOfAttachments, onDeleteAttachment } = props;

  return (
    <Container hasItems={true}>
      <FileAttachmentContainer>
        <FileAttachment
          type="file"
          accept=".jpeg, .jpg, .png, .pdf"
          onChange={e => {
            e.preventDefault();
            const {
              target: { files }
            } = e;

            if (!files || !files[0]) {
              return;
            }

            if (!isValidFileExtension(files[0].type)) {
              return showErrorValidExtensionToast();
            }

            const maxSize = 1048576 * MAX_MEGABYTES; // 1mb = 1048576
            if (files[0].size > maxSize) {
              showErrorToast(
                `Error uploading file. Your file is too big. Please upload a file less than ${MAX_MEGABYTES}mb. Please contact navigator@kindbody.com if you need assistance.`
              );
              return;
            }

            setListOfAttachments(listOfAttachments.concat(fileListArray(files)));
          }}
        />
        <FileAttachmentWrapper>
          <PaperclipIcon />
          <AttachFileText>Attach File</AttachFileText>
        </FileAttachmentWrapper>
        <FileAttachmentWrapperDescription>
          {t('upload_button.help_text', { megabytes: MAX_MEGABYTES })}
        </FileAttachmentWrapperDescription>
      </FileAttachmentContainer>
      <FileListWrapper>
        {listOfAttachments.map((file, idx) =>
          renderAttachmentLink(file, idx, () => onDeleteAttachment(idx))
        )}
      </FileListWrapper>
    </Container>
  );
};
